module.exports = __webpack_public_path__ + "images/68eaa42bf46fea5ca7ee5b6603f97397.gif";